import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const MoonIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ height = 16, width = 15, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M10 2.49995C10.11 2.49995 10.2192 2.49995 10.3275 2.49995C9.25697 3.49471 8.56885 4.83316 8.38276 6.28264C8.19668 7.73212 8.5244 9.20098 9.30897 10.4339C10.0935 11.6668 11.2853 12.5858 12.6772 13.0312C14.0691 13.4765 15.573 13.4201 16.9275 12.8716C16.4065 14.1254 15.5548 15.2141 14.4635 16.0218C13.3722 16.8295 12.0821 17.3258 10.7308 17.4578C9.3795 17.5897 8.01774 17.3524 6.79076 16.7711C5.56379 16.1898 4.51761 15.2864 3.76385 14.1571C3.01008 13.0279 2.57698 11.7152 2.51076 10.3591C2.44454 9.003 2.74767 7.65437 3.38783 6.45705C4.02799 5.25973 4.98116 4.25864 6.14566 3.56056C7.31016 2.86249 8.64231 2.49361 10 2.49329V2.49995Z"
          stroke="#1677FF"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
